package mapsearch

import dev.fritz2.core.RootStore
import kotlinx.coroutines.Job

enum class SearchLead {
    Map, Global
}

class SearchSwitch : RootStore<SearchLead>(SearchLead.Map, Job())
